module.exports = __webpack_public_path__ + "static/lte-impianti-logo-completo-ec5c06b6f2e54e51efbff6d5a93082f9.svg";